angular.module('EdxCommonModule')
  .directive('edxMessagePanel', function() {
    return {
      restrict: 'E',
      scope: {
        edxMessage: '='
      },
      templateUrl: '/resources/components/common/message-panel/message-panel.directive.html',
      controller: [function() {
          var vm = this;
        }
      ],
      controllerAs: 'vm',
      bindToController: true
    };
  });